"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("./toyota.css");
const sizings = {
  // heading
  heading72: "72px/80px",
  heading56: "56px/56px",
  heading14: "14px/1.4",
  heading01: "48px/56px",
  heading01_mobile: "40px/48px",
  heading02: "40px/48px",
  heading02_mobile: "32px/40px",
  heading03: "24px/32px",
  heading04: "20px/28px",
  heading05: "16px/24px",
  // display
  display01: "96px/1.4",
  display01_mobile: "60px/1.4",
  display02: "80px/1.4",
  display02_mobile: "40px/1.4",
  display03: "40px/1.4",
  display03_mobile: "32px/1.4",
  display04: "24px/1.4",
  display05: "16px/1.4",
  // body
  body01: "16px/28px",
  body02: "14px/1.4",
  //label
  legal01: "10px/1.4",
  button01: "14px/24px",
  label01: "12px/16px",
  label10: "10px/1.4",
  button02: "12px/1.4",
  overline01: "12px/1.4",
  input01: "14px/1.4"
};
const aliases = {
  spacing: {},
  weight: {
    light: "350",
    book: "400",
    regular: "500",
    semibold: "600",
    bold: "700"
  }
};
const defaults = {
  spacing: "normal"
};
var _default = exports.default = {
  ToyotaType: {
    sizings,
    aliases,
    defaults,
    family: "ToyotaTypeReact"
  }
};